import { getAccessTokenFromCookie } from "../util/authentication";
import {
  TOR_SERVICE_API_ADD_TIME_OFF_REQUEST_EVENT,
  TOR_SERVICE_API_GET_TIME_OFF_REQUEST_TYPES,
  TOR_SERVICE_API_GET_LATEST_TIME_OFF_REQUEST_EVENT_BY_TOR_ID,
  TOR_SERVICE_API_GET_TIME_OFF_EVENTS_BY_TOR_ID,
  TOR_SERVICE_API_GET_TIME_OFF_REQUEST_SNAPSHOTS_BY_EMPLOYEE_AND_DATE,
  TOR_SERVICE_API_GET_TIME_OFF_REQUEST_SNAPSHOT_BY_REFERENCE_NUMBER,
  TOR_SERVICE_API_GET_TIME_OFF_REQUEST_SNAPSHOTS_BY_STATION_AND_DATE,
  TOR_SERVICE_API_GET_TIME_OFF_REQUEST_SNAPSHOT_BY_TOR_ID,
  TOR_SERVICE_API_TOR_EVENT_ELIGIBILITY,
  TOR_SERVICE_API_GET_WOP_LIST,
  TOR_SERVICE_API_ADD_WOP_FREEZE_REQUEST,
  TOR_SERVICE_API_GET_LATEST_WOP_FREEZE_EVENT,
  TOR_SERVICE_API_GET_WOP_FREEZE_EVENTS,
  TOR_SERVICE_API_GET_WOP_FREEZE_AUDIT_EVENT,
} from "../util/constants";
import {
  INVALID_REFERENCE_NUMBER_ERROR_MESSAGE,
  TIME_OFF_REQUEST_NOT_AUTHORIZED_ERROR_MESSAGE,
} from "../util/messageConstants";

export const fetchTimeOffRequestTypes = async (jobCode, station) => {
  const apiEndpoint =
    process.env.REACT_APP_TIME_OFF_REQUEST_API +
    TOR_SERVICE_API_GET_TIME_OFF_REQUEST_TYPES +
    "/" +
    jobCode +
    "/" +
    station;
  try {
    const response = await fetch(apiEndpoint, {
      headers: {
        "Content-Type": "application/json",
        authorization: "Bearer " + getAccessTokenFromCookie(),
      },
    });
    if (response.status !== 200) {
      console.error(`Error with ${response.status} status code`);
      return {};
    }
    return response;
  } catch (error) {
    console.log("fetchTimeOffRequestTypes", error);
    return {};
  }
};

export const fetchEmployeeTimeOffRequestSnapshots = async (eid, dateType, startDate, endDate) => {
  const apiEndpoint =
    process.env.REACT_APP_TIME_OFF_REQUEST_API +
    TOR_SERVICE_API_GET_TIME_OFF_REQUEST_SNAPSHOTS_BY_EMPLOYEE_AND_DATE +
    "/" +
    eid +
    "/" +
    dateType +
    "/" +
    startDate +
    "/" +
    endDate;
  const response = await fetch(apiEndpoint, {
    headers: {
      "Calling-User-EID": eid,
      "Content-Type": "application/json",
      authorization: "Bearer " + getAccessTokenFromCookie(),
    },
  });
  if (!response.ok) {
    if (response.status === 400) {
      return response;
    }
    console.error(response);
    throw Error(`GET ${apiEndpoint} API Call failed.`);
  }
  return response;
};

export const fetchEmployeeTimeOffRequestSnapshotsByStation = async (eid, station, dateType, startDate, endDate) => {
  const apiEndpoint =
    process.env.REACT_APP_TIME_OFF_REQUEST_API +
    TOR_SERVICE_API_GET_TIME_OFF_REQUEST_SNAPSHOTS_BY_STATION_AND_DATE +
    "/" +
    station +
    "/" +
    dateType +
    "/" +
    startDate +
    "/" +
    endDate;
  const response = await fetch(apiEndpoint, {
    headers: {
      "Calling-User-EID": eid,
      "Content-Type": "application/json",
      authorization: "Bearer " + getAccessTokenFromCookie(),
    },
  });
  if (!response.ok) {
    if (response.status === 400) {
      return response;
    }
    throw Error(`GET ${apiEndpoint} API Call failed.`);
  }
  return response;
};

export const addTimeOffRequest = async (payload) => {
  const apiEndpoint = process.env.REACT_APP_TIME_OFF_REQUEST_API + TOR_SERVICE_API_ADD_TIME_OFF_REQUEST_EVENT;
  try {
    const response = await fetch(apiEndpoint, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        authorization: "Bearer " + getAccessTokenFromCookie(),
      },
      body: JSON.stringify(payload),
    });
    if (response.status !== 200) {
      console.error(`Error with ${response.status} status code`);
      return {};
    }
    return response;
  } catch (error) {
    console.log("fetchTimeOffRequestTypes", error);
    return {};
  }
};

export const fetchTimeOffRequestEventsByTorId = async (torId, eid, isAdminPage) => {
  const apiEndpoint =
    process.env.REACT_APP_TIME_OFF_REQUEST_API +
    TOR_SERVICE_API_GET_TIME_OFF_EVENTS_BY_TOR_ID +
    "/" +
    torId +
    "/" +
    eid +
    "/" +
    isAdminPage;
  const response = await fetch(apiEndpoint, {
    headers: {
      "Content-Type": "application/json",
      authorization: "Bearer " + getAccessTokenFromCookie(),
    },
  });
  if (!response.ok) {
    throw Error(`GET ${apiEndpoint} API Call failed.`);
  }
  return response;
};

export const fetchTimeOffRequestSnapshotByReferenceNumber = async (referenceNumber, eid, station, isAdminPage) => {
  const apiEndpoint =
    process.env.REACT_APP_TIME_OFF_REQUEST_API +
    TOR_SERVICE_API_GET_TIME_OFF_REQUEST_SNAPSHOT_BY_REFERENCE_NUMBER +
    "/" +
    referenceNumber +
    "/" +
    eid +
    "/" +
    station +
    "/" +
    isAdminPage;
  const response = await fetch(apiEndpoint, {
    headers: {
      "Content-Type": "application/json",
      authorization: "Bearer " + getAccessTokenFromCookie(),
    },
  });
  if (response.status === 200) {
    return await response.json();
  } else if (response.status === 403) {
    return { message: TIME_OFF_REQUEST_NOT_AUTHORIZED_ERROR_MESSAGE };
  } else if (response.status === 404) {
    return { message: INVALID_REFERENCE_NUMBER_ERROR_MESSAGE };
  } else {
    throw Error(`GET ${apiEndpoint} API Call failed with unknown error.`);
  }
};

export const fetchLatestTimeOffRequestEventByTorId = async (torId) => {
  const apiEndpoint =
    process.env.REACT_APP_TIME_OFF_REQUEST_API +
    TOR_SERVICE_API_GET_LATEST_TIME_OFF_REQUEST_EVENT_BY_TOR_ID +
    "/" +
    torId;
  const response = await fetch(apiEndpoint, {
    headers: {
      "Content-Type": "application/json",
      authorization: "Bearer " + getAccessTokenFromCookie(),
    },
  });
  if (!response.ok) {
    throw Error(`GET ${apiEndpoint} API Call failed.`);
  }
  return response;
};

export const fetchTimeOffRequestSnapshotByTorId = async (torId, isLongPollFetch = false) => {
  const apiEndpoint =
    process.env.REACT_APP_TIME_OFF_REQUEST_API + TOR_SERVICE_API_GET_TIME_OFF_REQUEST_SNAPSHOT_BY_TOR_ID + "/" + torId;
  const response = await fetch(apiEndpoint, {
    headers: {
      "Content-Type": "application/json",
      authorization: "Bearer " + getAccessTokenFromCookie(),
    },
  });

  if (!isLongPollFetch) {
    if (!response.ok) {
      throw Error(`GET ${apiEndpoint} API Call failed.`);
    }
  }
  return response;
};

export const fetchTimeOffRequestWOPEvents = async (station, workgroup, date, wopType) => {
  const apiEndpoint =
    process.env.REACT_APP_TIME_OFF_REQUEST_API +
    TOR_SERVICE_API_GET_WOP_LIST +
    "/" +
    station +
    "/" +
    workgroup +
    "/" +
    date +
    "/" +
    wopType;
  const response = await fetch(apiEndpoint, {
    headers: {
      "Content-Type": "application/json",
      authorization: "Bearer " + getAccessTokenFromCookie(),
    },
  });
  if (!response.ok) {
    throw Error(`GET ${apiEndpoint} API Call failed.`);
  }
  return response;
};

export const fetchLatestTimeOffRequestWOPFreezeEvent = async (station, workgroup, date, wopType) => {
  const apiEndpoint =
    process.env.REACT_APP_TIME_OFF_REQUEST_API +
    TOR_SERVICE_API_GET_LATEST_WOP_FREEZE_EVENT +
    "/" +
    station +
    "/" +
    workgroup +
    "/" +
    date +
    "/" +
    wopType;
  const response = await fetch(apiEndpoint, {
    headers: {
      "Content-Type": "application/json",
      authorization: "Bearer " + getAccessTokenFromCookie(),
    },
  });

  if (!response.ok) {
    throw Error(`GET ${apiEndpoint} API Call failed.`);
  }
  return response;
};

export const addTimeOffRequestWOPFreezeEvent = async (payload) => {
  const apiEndpoint = process.env.REACT_APP_TIME_OFF_REQUEST_API + TOR_SERVICE_API_ADD_WOP_FREEZE_REQUEST;
  try {
    const response = await fetch(apiEndpoint, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        authorization: "Bearer " + getAccessTokenFromCookie(),
      },
      body: JSON.stringify(payload),
    });

    if (!response.ok) {
      if (response.status === 400) {
        return response;
      }
      throw Error(`GET ${apiEndpoint} API Call failed.`);
    }

    return response;
  } catch (error) {
    console.log("addTimeOffRequestWOPFreezeEvent", error);
    return error;
  }
};

export const fetchTimeOffRequestWOPAuditTimes = async (station, workgroup, date, wopType) => {
  const apiEndpoint =
    process.env.REACT_APP_TIME_OFF_REQUEST_API +
    TOR_SERVICE_API_GET_WOP_FREEZE_EVENTS +
    "/" +
    station +
    "/" +
    workgroup +
    "/" +
    date +
    "/" +
    wopType +
    "/AUDIT";
  const response = await fetch(apiEndpoint, {
    headers: {
      "Content-Type": "application/json",
      authorization: "Bearer " + getAccessTokenFromCookie(),
    },
  });
  if (!response.ok) {
    throw Error(`GET ${apiEndpoint} API Call failed.`);
  }
  return response;
};

export const fetchTimeOffRequestWOPAuditEvent = async (station, workgroup, date, wopType, createdAt) => {
  const apiEndpoint =
    process.env.REACT_APP_TIME_OFF_REQUEST_API +
    TOR_SERVICE_API_GET_WOP_FREEZE_AUDIT_EVENT +
    "/" +
    station +
    "/" +
    workgroup +
    "/" +
    date +
    "/" +
    wopType +
    "/" +
    createdAt;
  const response = await fetch(apiEndpoint, {
    headers: {
      "Content-Type": "application/json",
      authorization: "Bearer " + getAccessTokenFromCookie(),
    },
  });
  if (!response.ok) {
    throw Error(`GET ${apiEndpoint} API Call failed.`);
  }
  return response;
};

export const isTOREventEligible = async (torEvent) => {
  const apiEndpoint =
    process.env.REACT_APP_TIME_OFF_REQUEST_API +
    TOR_SERVICE_API_TOR_EVENT_ELIGIBILITY +
    "/" +
    torEvent.station +
    "/" +
    torEvent.requestingEmployeeId +
    "?" +
    "requestingShifts=" +
    buildShiftStartQueryString(torEvent.requestingShifts);

  const response = await fetch(apiEndpoint, {
    headers: {
      "Content-Type": "application/json",
      authorization: "Bearer " + getAccessTokenFromCookie(),
    },
  });

  return response.status === 200;
};

export const buildShiftStartQueryString = (requestingShifts) => {
  let shiftStarts = [];
  requestingShifts.forEach((shift) => {
    shiftStarts.push(shift.shiftStart);
  });
  return shiftStarts.join(",");
};
